import Echo from 'laravel-echo'

window.Pusher = require('pusher-js')

export class Brotcast {
  instance
  Echo
  system
  client
  readyCallbacks = []

  /**
   * Make a new Brotcast instance.
   *
   * @returns {Brotcast}
   */
  static brotcast () {
    if (!Brotcast.prototype.instance) {
      Brotcast.prototype.instance = new Brotcast()
    }
    return Brotcast.prototype.instance
  }

  ready () {
    return new Promise((resolve, reject) => {
      if (this.Echo) {
        resolve(this)
      } else {
        this.readyCallbacks.push(resolve)
      }
    })
  }

  /**
   * Initialize the Brotcast connection.
   *
   * @param key Pusher key
   * @param wsHost Pusher host
   * @param wsPort Pusher port
   * @param apiUrl Brezel API URL
   * @param client Client hostname the user has access to
   * @param system System identifier of Brezel
   * @param accessToken
   */
  init ({ key, wsHost, wsPort = 6001, apiUrl, client, system, accessToken }) {
    this.client = client
    this.system = system

    this.Echo = null
    window.Echo = null

    this.Echo = new Echo({
      broadcaster: 'pusher',
      key: key,
      wsHost: wsHost,
      wsPort: wsPort,
      forceTLS: false,
      disableStats: true,
      authEndpoint: `${apiUrl}/${client}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    })

    window.Echo = this.Echo

    this.readyCallbacks.forEach(func => func(this))
    this.readyCallbacks = []
  }

  workflowsChannel () {
    return this.Echo.private(`bakery.system.${this.system}.workflows`)
  }

  workflowChannel (id) {
    return this.Echo.private(`bakery.system.${this.system}.workflow.${id}`)
  }

  workflowDebugChannel (id) {
    return this.Echo.private(this.getWorkflowDebugChannelName(id))
  }

  leaveWorkflowDebugChannel (id) {
    this.Echo.leave(this.getWorkflowDebugChannelName(id))
  }

  userChannel (user) {
    return this.Echo.private(`brezel.system.${this.system}.user.${user.id}`)
  }

  getWorkflowDebugChannelName (id) {
    return `bakery.system.${this.system}.workflow.${id}.debug`
  }
}

export default Brotcast.brotcast()
